import { useState } from "react";
import { X, Sparkles, ArrowRight } from "lucide-react";

export default function HumanityRisingRibbon() {
    const [isOpen, setIsOpen] = useState(true);

    const handleLearnMore = () => {
        const section = document.getElementById("humanity-rising-section");

        if (section) {
            section.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <aside className="fixed bottom-4 left-1/2 z-[9999] w-[calc(100%-1.5rem)] max-w-5xl -translate-x-1/2">
            <div className="relative overflow-hidden rounded-[18px] border-[4px] border-black bg-[#6f2dbd] shadow-[7px_7px_0_#000]">
                <div className="absolute inset-0 opacity-20 [background-image:radial-gradient(#fff_1px,transparent_1px)] [background-size:12px_12px]" />

                <div className="relative flex flex-col gap-3 px-4 py-3 pr-12 md:flex-row md:items-center md:justify-between md:px-5">
                    <div className="flex items-center gap-3">
                        <div className="hidden h-11 w-11 shrink-0 items-center justify-center rounded-full border-[3px] border-black bg-[#ffd21f] text-black shadow-[3px_3px_0_#000] sm:flex">
                            <Sparkles size={23} strokeWidth={3} />
                        </div>

                        <p className="text-sm font-black leading-snug text-white md:text-base">
                            <span className="text-[#ffd21f]">
                                Join the Humanity Rising Movement!
                            </span>{" "}
                            Share your story, earn service learning hours, and be eligible for
                            scholarship awards.
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={handleLearnMore}
                        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full border-[3px] border-black bg-[#ff3366] px-5 py-2 text-xs font-black uppercase italic text-white shadow-[4px_4px_0_#000] transition hover:-translate-y-1 hover:shadow-[6px_6px_0_#000] md:text-sm"
                    >
                        Learn More
                        <ArrowRight size={18} strokeWidth={3} />
                    </button>

                    <button
                        type="button"
                        onClick={() => setIsOpen(false)}
                        aria-label="Close Humanity Rising popup"
                        className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full border-[3px] border-black bg-white text-black shadow-[3px_3px_0_#000] transition hover:-translate-y-0.5 hover:bg-[#ffd21f]"
                    >
                        <X size={18} strokeWidth={4} />
                    </button>
                </div>
            </div>
        </aside>
    );
}